import apiSchedule from '@/api/schedules';
import apiOption from '@/api/option';

const defaultState = () => ({
	scheduleResults: [],
	schedulePagination: '',
	optionSupplier: [],
	responSukses: '',
	alert: '',
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {
	listschedule(state, data) {
		state.scheduleResults = data.data;
		state.schedulePagination = data.pagination;
	},
	listOptionSupplier(state, data) {
		state.optionSupplier = data
	},
	listOptionWarehouse(state, data) {
		state.optionWarehouse = data
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataSchedules(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getSchedules({ commit }, value) {
		return new Promise((resolve) => {
			apiSchedule.getSchedules(value).then(({ data: { data } }) => {
				commit('listschedule', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('listschedule', { data: [], pagination: {} });
			});
		});
	},
	getSchedulesAll({ commit }, value) {
		apiSchedule.getSchedulesAll(value).then(({ data: { data } }) => {
			commit('listschedule', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listschedule', { data: [], pagination: {} });
		});
	},
	getOptionSupplier({ commit }, value) {
		apiOption.getOptionSupplier(value).then(({ data: { data } }) => {
			commit('listOptionSupplier', data.results);
		}).catch(() => {
			commit('listOptionSupplier', []);
		});
	},
	getOptionWarehouse({ commit }, value) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouse(value).then(({ data: { data } }) => {
				commit('listOptionWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('listOptionWarehouse', []);
			});
		});
	},
	async exportSchedules({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSchedule.exportSchedules(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Jadwal'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportSchedulesAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSchedule.exportSchedulesAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Jadwal'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};